/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublicationUrl
 */
export interface PublicationUrl {
    /**
     * 
     * @type {string}
     * @memberof PublicationUrl
     */
    url: string;
}

/**
 * Check if a given object implements the PublicationUrl interface.
 */
export function instanceOfPublicationUrl(value: object): value is PublicationUrl {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function PublicationUrlFromJSON(json: any): PublicationUrl {
    return PublicationUrlFromJSONTyped(json, false);
}

export function PublicationUrlFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicationUrl {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
    };
}

export function PublicationUrlToJSON(json: any): PublicationUrl {
    return PublicationUrlToJSONTyped(json, false);
}

export function PublicationUrlToJSONTyped(value?: PublicationUrl | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
    };
}

